const AUTH_STORAGE_KEY = 'divittaAuth';

function getStorage() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.sessionStorage;
}

export function clearLegacyAuth() {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(AUTH_STORAGE_KEY);
}

export function getStoredAuth() {
  const storage = getStorage();
  if (!storage) {
    return { user: null };
  }

  clearLegacyAuth();

  try {
    const rawValue = storage.getItem(AUTH_STORAGE_KEY);
    const parsedValue = rawValue ? JSON.parse(rawValue) : null;

    if (!parsedValue || typeof parsedValue !== 'object') {
      return { user: null };
    }

    return {
      ...parsedValue,
      user: parsedValue.user || null
    };
  } catch (error) {
    storage.removeItem(AUTH_STORAGE_KEY);
    return { user: null };
  }
}

export function saveAuth(auth) {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  clearLegacyAuth();
  storage.setItem(AUTH_STORAGE_KEY, JSON.stringify(auth));
}

export function clearAuth() {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  storage.removeItem(AUTH_STORAGE_KEY);
  clearLegacyAuth();
}
